import { Dispatch, SetStateAction } from 'react';
import { Icon, IconsEnum } from 'components/Icons';

import { Button } from 'components/button/Button';
import styles from 'components/page-content/registrati/registrati.module.scss';
import { useGetLabelsByKeys } from 'hooks/useLingUI';

export type ButtonRegistrationWrapperProp = {
  handleGoBack: Dispatch<SetStateAction<boolean>>;
  children?: React.ReactNode;
  isNextDisabled?: boolean;
  lastStep?: string;
  isLoading?: boolean;
};

export const ButtonRegistrationWrapper = ({
  handleGoBack,
  children,
  isNextDisabled = false,
  lastStep,
  isLoading,
}: ButtonRegistrationWrapperProp) => {
  const [labelContinua, labelIndietro] = useGetLabelsByKeys(['continua', 'indietro']);

  return (
    <div className={styles.buttonsContainer}>
      <button
        type="button"
        className={styles.backButton}
        onClick={(e) => {
          e.stopPropagation();
          handleGoBack(true);
        }}
      >
        <Icon iconId={IconsEnum.ARROW} className={styles.icon} color="var(--color-on-bg-primary)" />
        <span className={styles.btnBackLabel}>{labelIndietro}</span>
      </button>
      {children}

      {/* disabled={isNextDisabled}  */}
      <Button className={styles.nextButton} type="submit" isLoading={isLoading}>
        {lastStep ?? labelContinua}
      </Button>
    </div>
  );
};
